import { API_ROUTES } from "definitions/constants/routeConstants";
import { generatePath as caminoGeneratePath } from "../v1";

export function apiIssuePathById(issueId: string | undefined) {
  return caminoGeneratePath({ path: API_ROUTES.issues.show, params: { id: issueId || "" } });
}
